[
    {
        "id": "6f1d2c3a-8b14-4e09-9c2e-1a7b0d4e5f60",
        "name": "Company context",
        "markdown": "Patient Watch is a clinician-facing outcomes platform.\n\n- Clinics collect PROMs and follow-up without extra work on clinic days.\n- Patients complete diaries on their phone; clinicians see progress in one dashboard.\n- Used for injections, surgery pathways, and post-market / study follow-up.\n- Typical ask: a short walkthrough, not a long demo."
    },
    {
        "id": "d0a6c3e4-5f71-4c92-b3a4-8e0f2b3c4d55",
        "name": "MSK focus",
        "markdown": "For MSK / ortho / sports clinics:\n\n- Injection and surgery pathways (knee, hip, shoulder, foot and ankle).\n- PROMs such as WOMAC, Oxford, FAAM, QuickDASH, without chasing paper forms.\n- Clearer follow-up between visits so the clinician sees who is improving and who is not."
    }
]
